export default __webpack_public_path__ + "static/media/widgetStreetMap.bc7583a6.svg";